import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_2 = { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }
const _hoisted_3 = { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }
const _hoisted_4 = { class: "s10 mt--5-5 flex-right gap-4" }
const _hoisted_5 = { class: "s20 items-center gap-6 px-5 pb-4 collapse-content active" }
const _hoisted_6 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_8 = { class: "grid4 px-1" }
const _hoisted_9 = { class: "grid4 px-1" }

import { reactive, ref, onMounted, computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomWidget',
  props: {
    title: { type: String, required: true },
    loading: Boolean,
    items: { type: Object, required: true }
},
  setup(__props) {

// @ts-expect-error raison: lib externe mal typée
const props = __props;
const minimized = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: "/icons/icon-panel-open.svg",
          class: "size-xs icon-neutral mr-2 collapse-icon-open",
          alt: ""
        }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          src: "/icons/icon-panel-close.svg",
          class: "size-xs icon-neutral mr-2 collapse-icon-close",
          alt: ""
        }, null, -1)),
        _createTextVNode(" " + _toDisplayString(props.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "action")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
      _renderSlot(_ctx.$slots, "header"),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
      (__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Chargement des éléments... "))
        : (__props.items.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Aucun élément disponible "))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items.slice(0, 12), (item) => {
          return _renderSlot(_ctx.$slots, "item", {
            key: item.id,
            item: item
          })
        }), 128))
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass({'collapse-content': minimized.value})
      }, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items.slice(12), (item) => {
            return _renderSlot(_ctx.$slots, "item", {
              key: item.id,
              item: item
            })
          }), 128))
        ])
      ], 2),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
      (__props.items.length > 12)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(["px-5 py-4 bg-color rounded-100 font-bold text-lg collapse-open align-right", {'active': !minimized.value}]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (minimized.value = !minimized.value))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: "/icons/icon-panel-open.svg",
              class: "size-xs icon-neutral mr-2 collapse-icon-open",
              alt: ""
            }, null, -1),
            _createElementVNode("img", {
              src: "/icons/icon-panel-close.svg",
              class: "size-xs icon-neutral mr-2 collapse-icon-close",
              alt: ""
            }, null, -1),
            _createTextVNode(" Voir tous ", -1)
          ]))], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})